import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=09f4b4fa&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=09f4b4fa&prod&lang=less&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f4b4fa",
  null
  
)

export default component.exports